<template>
    <div class="tab-header">
        <el-tabs class="tab-header-list" v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane
                v-for="(tabItem, tebIndex) in tabList"
                :key="tebIndex"
                :name="tabItem.name">
                <span slot="label">
                    {{ tabItem.special ? (isSelf ? '关注我的人' : '关注他的人') : (isSelf ? '我' : '他') + tabItem.label}}
                    <span class="label-num" v-if="isCount">{{ tabItem.count || 0 }}</span>
                </span>
            </el-tab-pane>
        </el-tabs>
        <ul class="sort-list" v-if="isSort">
            <li
                v-for="(item, index) in sortList"
                :key="index"
                :class="{'active': sortType === item.sort }"
                @click="onSwitchSort(item)">
                {{ item.value }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        tabName: {
            type: String,
            default: ''
        },
        tabList: {
            type: Array,
            default: () => []
        },
        isSort: {
            type: Boolean,
            default: true
        },
        isCount: {
            type: Boolean,
            default: true
        },
        isSelf: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            activeName: '',
            sortType: '-created_on',
            sortList: [
                { value: '时间倒序', sort: '-created_on' },
                { value: '时间正序', sort: 'created_on' }
            ]
        }
    },
    watch: {
        tabName: {
            handler (val) {
                this.activeName = val
            },
            immediate: true
        },
        sortType: {
            handler (val) {
                window.scrollTo(0, 0)
                this.$emit('getSortType', val)
            }
        }
    },
    created () {
        const { name } = this.$route.meta
        if (name === 'question') {
            this.sortList.push({ value: '访问量', sort: 'view' })
        } else {
            this.sortList.push({ value: '获赞最多', sort: '-vote_up' })
        }
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        // 切换tab
        handleTabClick (data) {
            const { tabName } = this.$route.query
            if (tabName !== data.name) {
                this.$router.push({
                    query: {
                        tabName: data.name
                    }
                })
                this.$emit('getTabName', data.name)
            }
        },
        // 切换排序类型
        onSwitchSort (item) {
            this.sortType = item.sort
        },
        // 滚动吸顶
        handleScroll () {
            const contentWrapper = document.querySelector('.bk-personal_center')
            const headerWraaper = document.querySelector('.tab-header')
            if (!contentWrapper && !headerWraaper) return
            if (window.scrollY > 183) {
                contentWrapper.style.paddingTop = '68px'
                headerWraaper.classList = 'tab-header is-fixed'
            } else {
                contentWrapper.style.paddingTop = '16px'
                headerWraaper.classList = 'tab-header'
            }
        }
    }
}
</script>

<style lang="scss">
    .tab-header-list {
        flex: 1;
        height: 52px;
        line-height: 52px;
        .el-tabs__active-bar {
            min-width: 90px !important;
        }
        .el-tabs__item {
            min-width: 80px !important;
            text-align: center;
            box-sizing: content-box;
            position: relative;
            left: 3px;
            .label-num {
                font-size: 12px;
                padding: 2px 8px;
                background: #f0f1f5;
                color: #63656e;
                font-weight: 700;
                border-radius: 11px;
                margin-right: 5px;
            }
            &:hover, &.is-active {
                .label-num {
                    color: #3a84ff;
                    background: #e1ecff;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    .tab-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 25px 0 10px;
        height: 52px;
        border-bottom: 1px solid #dcdee5;
        &.is-fixed {
            position: fixed;
            top: 60px;
            width: 1200px;
            background: #fff;
            z-index: 5;
        }
        .sort-list {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #979ba5;
            >li {
                margin-left: 20px;
                cursor: pointer;
                position: relative;
                &.active,
                &:hover {
                    color: #313238;
                }
                &:not(:first-child)::before {
                    content: '';
                    width: 1px;
                    height: 12px;
                    position: absolute;
                    top: 3px;
                    left: -10px;
                    background: #979ba5;
                }
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// tabHeader.vue?51c8476c